
/** Class for Address Details*/
export class AddressDetails {
    /** kyc Verified By */
    kycVerifiedBy: string;
    /** Unique Identifier for DTO*/
    id: string;
    /** Unique Identifier for Nominee */
    nomineeId: string;
    /** Unique Identifier for Guardian */
    guardianId: string;
    /** Unique Identifier for Investor */
    investorId: string;
    /** Address Of Identifer */
    addressOf: string;
    /** Address Type as Permanent or Current */
    addressType: string;
    /** Address in String */
    address: string;
    /** City for address */
    city: string;
    /** Pin Code for City */
    zipCode: string;
    /** State for Address*/
    state: string;
    /** Address Proof Type if any */
    addressProofType: string;
    /** address */
    address1: string;
    /** address */
    address2: string;
    /** UPDATE VALUE */
    isUpdated: string;

    /** Method to initialize Component */
    constructor() {
        this.isUpdated = 'N';
    }
}
